// StatusBadge — T052

interface StatusBadgeProps {
  state: string;
  size?: 'sm' | 'md' | 'lg';
}

const stateColors: Record<string, string> = {
  UP: 'bg-status-up text-white',
  DEGRADED: 'bg-status-degraded text-black',
  DOWN: 'bg-status-down text-white',
  operational: 'bg-status-up text-white',
  partial_outage: 'bg-status-degraded text-black',
  major_outage: 'bg-status-down text-white',
  unknown: 'bg-text-muted text-white',
};

const sizeClasses: Record<string, string> = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-3 py-1 text-sm',
  lg: 'px-4 py-2 text-base 2xl:px-6 2xl:py-3 2xl:text-lg',
};

export default function StatusBadge({ state, size = 'md' }: StatusBadgeProps) {
  const color = stateColors[state] || stateColors.unknown;
  const sizeClass = sizeClasses[size];
  const label = state.replace(/_/g, ' ').toUpperCase();

  return (
    <span className={`inline-flex items-center rounded-full font-semibold ${color} ${sizeClass}`}>
      {label}
    </span>
  );
}
